import React from 'react';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';

type Props = {
    value: string,
};

export const DefaultCell = ({value}: Props) => (
    <EllipsisTextHint title={value}>
        {value}
    </EllipsisTextHint>
);
